import { AddTenantUomNameMutation } from "~/gql/mutations/tenantUom.generated";
import { GetTenantUomNamesQuery } from "~/gql/queries/tenantUom.generated";

export const tenantUomEndpoints = {
	AddTenantUomName: {
		invalidatesTags: ["TenantUomNames"] as AddTagTypes,
		transformResponse: (res: AddTenantUomNameMutation) => res
	},
	GetTenantUomNames: {
		providesTags: ["TenantUomNames"] as AddTagTypes,
		transformResponse: (res: GetTenantUomNamesQuery) => res
	}
};
